<template>
  <v-navigation-drawer class="" v-model="MenuDrawer" app>
    <IphLogo />
    <v-divider></v-divider>
    <AvatarUser v-if="GET_user" />

    <v-divider></v-divider>

    <v-list dense nav>
      <v-list-item link :to="{ name: 'home' }" color="red darken-2">
        <v-list-item-icon>
          <v-icon>mdi-view-dashboard</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>Página Inicial</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link :to="{ name: 'scales' }" color="red darken-2">
        <v-list-item-icon>
          <v-icon>mdi-calendar-range</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>Escala</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link :to="{ name: 'paychecks' }" color="red darken-2">
        <v-list-item-icon>
          <v-icon>mdi-file-chart</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>Contracheques</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link :to="{ name: 'income_tax' }" color="red darken-2">
        <v-list-item-icon>
          <v-icon>mdi-currency-usd</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>Imposto de Renda</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider></v-divider>

    <v-list dense nav>
      <v-list-item link to="/">
        <v-list-item-icon>
          <v-icon>mdi-email-multiple</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>Fale Conosco</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider></v-divider>

    <template v-slot:append>
      <div class="pa-2 mb-16">
        <v-btn class="menu-bg-gradinte-iph-red white--text" block @click="ActionSignOut"
          >Sair</v-btn
        >
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import IphLogo from './IphLogo'
import AvatarUser from './AvatarUser'

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'MainMenu',
  data: function () {
    return {
      inset: false,
      model: 0,
      MenuDrawer: true,
      menuRh: false,
      menuComunication: false,
      menuEcommerce: false,
      menuCourse: false,
      menuUsers: false,
      activeEmploeeMenu: true,
      activeLinkText: '',
      // activeCurrentPage: 'router-link-active',
      admins: [
        ['Management', 'mdi-home'],
        ['Settings', 'mdi-home'],
      ],
      cruds: [
        ['Create', 'add'],
        ['Read', 'insert_drive_file'],
        ['Update', 'update'],
        ['Delete', 'delete'],
      ],
    }
  },
  components: {
    IphLogo,
    AvatarUser,
  },
  computed: {
    ...mapGetters('menu', ['GET_drawer']),
    ...mapGetters('auth', ['GET_user']),
  },
  created: function () {
    this.MenuDrawer = this.GET_drawer
  },
  methods: {
    ...mapActions('auth', ['ActionSignOut']),
  },
  watch: {
    GET_drawer: function () {
      this.MenuDrawer = this.GET_drawer
    },
    GET_user: function () {
      if (this.GET_user.authorization_type === 8 || this.GET_user.authorization_type === 1) {
        this.menuRh = true
      }
    },
  },
}
</script>
